const AudioPlayer = {

    init() {
        this.players = $('[component="AudioPlayer"]');
        if (!this.players.length) return;

        this.players.each((i, el) => {
            this.initPlayer($(el));
        });
    },

    initPlayer(el) {
        const audioUrl = el.data('audio');
        if (!audioUrl) return;

        const audio = new Audio();
        audio.preload = 'none';
        audio.src = audioUrl;
        const playBtn = el.find('.play');
        const elapsed = el.find('.elapsed');
        const total = el.find('.total');
        const progressContainer = el.find('.progress');
        const progressBar = el.find('.progress .slider');
        const volumeContainer = el.find('.volume');
        const volumeLevel = el.find('.volume .level');
        const muteBtn = el.find('.switch');

        // Set initial volume
        const savedVolume = localStorage.getItem('audioPlayerVolume');
        audio.volume = savedVolume !== null ? parseFloat(savedVolume) : 0.8;
        this.updateVolumeUI(volumeLevel, audio.volume);
        this.updateMuteIcon(muteBtn, audio.volume, audio.muted);

        // Events
        playBtn.click(() => {
            if (audio.paused) {
                audio.play().catch(err => console.error("AudioPlayer: Manual play failed", err));
            } else {
                audio.pause();
            }
        });

        audio.addEventListener('loadedmetadata', () => {
            total.text(this.formatTime(audio.duration));
        });

        audio.addEventListener('timeupdate', () => {
            if (audio.duration) {
                const percent = (audio.currentTime / audio.duration) * 100;
                progressBar.css('width', percent + '%');
                elapsed.text(this.formatTime(audio.currentTime));
            }
        });

        audio.addEventListener('play', () => {
            playBtn.attr('icon', 'pause_circle');
        });

        audio.addEventListener('pause', () => {
            playBtn.attr('icon', 'play_circle');
        });

        audio.addEventListener('ended', () => {
            progressBar.css('width', '0%');
            elapsed.text('00:00');
        });

        // Progress bar interaction
        let isDraggingProgress = false;
        let wasPausedBeforeDrag = true;

        const updateProgress = (e) => {
            if (!audio.duration || !isFinite(audio.duration)) return;

            const rect = progressContainer[0].getBoundingClientRect();
            if (rect.width <= 0) return;

            const clientX = (e.touches && e.touches.length) ? e.touches[0].clientX : 
                           (e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].clientX :
                           (e.clientX || (e.originalEvent && e.originalEvent.touches ? e.originalEvent.touches[0].clientX : 0));
            
            let x = clientX - rect.left;
            const percent = Math.max(0, Math.min(1, x / rect.width));
            const targetTime = percent * audio.duration;

            // Immediate UI update
            progressBar.css('width', (percent * 100) + '%');
            elapsed.text(this.formatTime(targetTime));

            // Actual seek
                try {
                if (audio.readyState >= 1) { 
                    audio.currentTime = targetTime;
                }
                } catch (err) {
                    console.error("AudioPlayer: Seek failed", err);
            }
        };

        const handleStart = (e) => {
            isDraggingProgress = true;
            wasPausedBeforeDrag = audio.paused;
            if (!wasPausedBeforeDrag) audio.pause();
            updateProgress(e);
        };

        const handleMove = (e) => {
            if (isDraggingProgress) {
                updateProgress(e);
                if (e.type === 'touchmove') e.preventDefault();
            }
        };

        const handleEnd = (e) => {
            if (isDraggingProgress) {
                updateProgress(e);
                isDraggingProgress = false;
                if (!wasPausedBeforeDrag) {
                    audio.play().catch(err => console.error("AudioPlayer: Play failed after seek", err));
                }
            }
        };

        progressContainer.on('mousedown touchstart', handleStart);
        $(window).on('mousemove touchmove', handleMove);
        $(window).on('mouseup touchend', handleEnd);

        // Volume interaction
        let isDraggingVolume = false;

        const updateVolume = (e) => {
            const rect = volumeContainer[0].getBoundingClientRect();
            const paddingLeft = parseInt(volumeContainer.css('padding-left')) || 0;
            const paddingRight = parseInt(volumeContainer.css('padding-right')) || 0;
            const innerWidth = rect.width - paddingLeft - paddingRight;

            if (innerWidth <= 0) return;

            const clientX = (e.touches && e.touches.length) ? e.touches[0].clientX : (e.clientX || (e.originalEvent && e.originalEvent.touches ? e.originalEvent.touches[0].clientX : 0));
            let x = clientX - rect.left - paddingLeft;
            
            const percent = Math.max(0, Math.min(1, x / innerWidth));
            
            audio.volume = percent;
            localStorage.setItem('audioPlayerVolume', percent);
            audio.muted = false;
            this.updateVolumeUI(volumeLevel, percent);
            this.updateMuteIcon(muteBtn, percent, false);
        };

        const handleVolumeStart = (e) => {
            isDraggingVolume = true;
            updateVolume(e);
        };

        const handleVolumeMove = (e) => {
            if (isDraggingVolume) updateVolume(e);
        };

        const handleVolumeEnd = () => {
            isDraggingVolume = false;
        };

        volumeContainer.on('mousedown touchstart', handleVolumeStart);
        $(window).on('mousemove touchmove', handleVolumeMove);
        $(window).on('mouseup touchend', handleVolumeEnd);

        muteBtn.click(() => {
            audio.muted = !audio.muted;
            this.updateMuteIcon(muteBtn, audio.volume, audio.muted);
        });
    },

    updateVolumeUI(volumeLevel, percent) {
        volumeLevel.css('width', (percent * 100) + '%');
    },

    updateMuteIcon(muteBtn, volume, isMuted) {
        if (isMuted || volume === 0) {
            muteBtn.attr('icon', 'volume_off');
        } else if (volume > 0.5) {
            muteBtn.attr('icon', 'volume_up');
        } else {
            muteBtn.attr('icon', 'volume_down');
        }
    },

    formatTime(seconds) {
        if (isNaN(seconds) || seconds === Infinity) return '00:00';
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        
        if (h > 0) {
            return h + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
        } else {
            return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
        }
    },

    resize() {
    },

}

export default AudioPlayer;
